import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const Booking = (props) => {
  const comment = props.event.extendedProps.comment

  const content = <div className='fc-event-main-frame'>
    {props.timeText &&
      <div className='fc-event-time'>{props.timeText}</div>
    }
    <div className='fc-event-title-container'>
      <div className='fc-event-title fc-sticky'>
        {props.event.title || <>&nbsp;</>}
      </div>
    </div>
  </div>

  if (comment) {
    return (
      <Tooltip title={comment}>
        {content}
      </Tooltip>
    );
  }

  return content
}

export default Booking